import type { Option } from "@/pages/users/components/users-filter";

export enum Roles {
    Admin = "Admin",
    Instructor = "Instructor",
    Trainee = "Trainee",
    Viewer = "Viewer",
}

export enum HeatRoles {
    Admin = 0,
    Instructor = 1,
    Trainee = 2,
}

export const RoleOptions: Option[] = [
    { id: "Admin", label: "Admin" },
    { id: "Instructor", label: "Instructor" },
    { id: "Trainee", label: "Trainee" },
];

export const StatusOptions: Option[] = [
    { id: "active", label: "Active", value: "Active" },
    { id: "pending", label: "Pending", value: "Pending" },
    { id: "deactivated", label: "Deactivated", value: "Inactive" },
];
